// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__SqBi_","iconWithCounter":"styles_iconWithCounter__mU2gN","counterForLabel":"styles_counterForLabel__IMoW8","counterForIcon":"styles_counterForIcon__upy__"};